import { useEffect } from 'react'

const VISIBILITY_THRESHOLD = 0.5

interface UseVisibilityTrackingParams {
  container: Element | null | undefined
  enabled: boolean
  onVisibilityChange: (isVisible: boolean) => void
}

/**
 * Hook to track element visibility using IntersectionObserver.
 * Triggers callback when element visibility crosses 50% threshold.
 */
export const useVisibilityTracking = ({
  container,
  enabled,
  onVisibilityChange,
}: UseVisibilityTrackingParams): void => {
  useEffect(() => {
    if (!container || !enabled) return

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry) {
          onVisibilityChange(entry.intersectionRatio >= VISIBILITY_THRESHOLD)
        }
      },
      {
        threshold: [0, VISIBILITY_THRESHOLD, 1],
      }
    )

    observer.observe(container)

    return () => {
      observer.disconnect()
    }
  }, [container, enabled, onVisibilityChange])
}
